<template>
    <div id="main" class="content">
        <div class="container">
            <section class="post_content" itemscope >
                <header class="post_header">
                    <h1 class="post_title">{{archiveName}}</h1>
                </header>
                <div class="post-Archive">
                    <div id="archives">
                        <div class='archive-title' v-for="(archive, index) in archives" :key="index">
                            <h3>{{index}}</h3>
                            <div class='archives archives-3' v-for="article in archive">
                                <div class="brick">
                                    <router-link :to="'/detail/' + article.id"><span class="time">{{article.date}}</span>{{article.title}}<span>({{article.comment_count}})</span></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'archive',
        props: ['id'],
        data: function(){
            return {
                archiveName: "",
                archiveID: this.id,
                archives: []
            }
        },
        created: function(){
            this.archiveName = this.$route.query.name;
            this.getList(this.$route);
        },
        methods: {
            getList: function(route){
                this.archiveName = this.$route.query.name;
                this.archiveID = route.params.id ? route.params.id : this.archiveID;
                this.$http.get("/archive/" + this.archiveID, {}, (res) => {
                    if(res.status){
                        this.archives = res.data;
                    }else{
                        console.log(res.msg);
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/archive.vue